// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class InstrumentNamesGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.INSTRUMENT_NAMES_GROUP, null, pfixFieldSet);
    }
    getName() {
        return this.GetValue(FieldsFactory.FIELD_NAME);
    }
    setName(name) {
        this.SetField(FieldsFactory.FIELD_NAME, name);
    }
}
